export enum NotificationEnum {
    AppointmentWithWrongId = 'pages_appointment_notification_wrong_id',
    FailedReceivingOfAppointments = 'pages_appointment_notification_failed_receiving_of_appointments',
    AppointmentSuccessCancellation = 'pages_appointment_notification_success_cancellation',
    AppointmentFailedCancellation = 'pages_appointment_notification_failed_cancellation',
    UpdateAppointmentNotification = 'update_appointment_notification',
    CreateAppointmentNotification = 'create_appointment_notification',
}
